import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';

export default (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const knowledgeStore = useKnowledgeStore();
  const configStore = useConfigStore();
  const { knowledgeId } = to.params as { knowledgeId: string };
  const { force, skipOrdered, silent } = to.query;

  if (to.name !== 'knowledge-viewer' || silent) return next();

  knowledgeStore.resetPath();

  const { knowledgeId: storedKnowledgeId } = storeToRefs(knowledgeStore);

  if (
    knowledgeId &&
    (knowledgeId !== storedKnowledgeId.value || force === '1')
  ) {
    knowledgeStore.getKnowledgeRootContent({
      knowledgeValue: knowledgeId,
      skipOrdered: skipOrdered === '1',
    });
  }
  configStore.initRoutesHistory();
  next();
};
